import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'
import vuetify from '@/plugins/vuetify'
import store from './store/index.js'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

Vue.config.productionTip = false
Vue.use(Vuetify)

Vue.prototype.$api = process.env.VUE_APP_API_URL;
Vue.prototype.$secretKey = process.env.VUE_APP_SECRET_KEY
Vue.use(VueToast);


new Vue({
	render: (h) => h(App),
	router,
	store,
	vuetify,
}).$mount('#app')
